import { takeLatest, all, call, put } from "redux-saga/effects";
import { API, graphqlOperation } from "aws-amplify";

import {
  fetchConfigurationStart,
  fetchConfigurationSuccess,
  fetchConfigurationError,
  updateRatesError,
} from "./configuration.actions";
import {
  FETCH_CONFIGURATION_START,
  UPDATE_RATES_START,
} from "./configuration.types";
import { listConfigurations } from "../../graphql/queries";
import { updateConfiguration as updateConfig } from "../../graphql/mutations";
import showErrorMessage from "../../utils/showErrorMessage";
import showSuccessMessage from "../../utils/showSuccessMessage";

export function* fetchConfiguration() {
  try {
    const res = yield API.graphql({
      ...graphqlOperation(listConfigurations),
      authMode: "API_KEY",
    });

    yield put(fetchConfigurationSuccess(res.data.listConfigurations.items[0]));
  } catch ({ errors }) {
    showErrorMessage(errors);
    yield put(fetchConfigurationError(errors));
  }
}

export function* updateRates({ payload }) {
  try {
    const { configuration, values } = payload;

    const input = {
      id: configuration.id,
      developerRate: values.developerRate,
      graphicsRate: values.designerRate,
      configurationId: 1,
    };

    yield API.graphql(graphqlOperation(updateConfig, { input }));
    showSuccessMessage();
    yield put(fetchConfigurationStart());
  } catch ({ errors }) {
    showErrorMessage(errors);
    yield put(updateRatesError(errors));
  }
}

// Configuration sagas
export function* onFetchConfigurationStart() {
  yield takeLatest(FETCH_CONFIGURATION_START, fetchConfiguration);
}

export function* onUpdateRatesStart() {
  yield takeLatest(UPDATE_RATES_START, updateRates);
}

export function* configurationSagas() {
  yield all([call(onFetchConfigurationStart), call(onUpdateRatesStart)]);
}
